"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _MetricsConfiguration_1 = require("./_MetricsConfiguration");
exports._MetricsConfigurationList = {
    type: "list",
    flattened: true,
    member: {
        shape: _MetricsConfiguration_1._MetricsConfiguration
    }
};
//# sourceMappingURL=_MetricsConfigurationList.js.map